import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Cars(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#481D77" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M18.0001 16.5295C17.427 17.1664 16.7197 17.6707 15.8783 18.0422C15.0369 18.4138 14.0675 18.5995 12.97 18.5995C11.97 18.5995 11.0463 18.4403 10.1988 18.1218C9.35133 17.8033 8.61664 17.3522 7.99473 16.7683C7.37282 16.1844 6.88506 15.4856 6.53143 14.6717C6.17779 13.8578 6.00098 12.9614 6.00098 11.9823C6.00098 10.9797 6.18084 10.0715 6.54057 9.2576C6.9003 8.44372 7.39721 7.75074 8.03131 7.17867C8.66542 6.60659 9.40926 6.16721 10.2629 5.86053C11.1165 5.55385 12.0371 5.40051 13.0248 5.40051C13.9394 5.40051 14.8387 5.5568 15.7228 5.86938C16.6069 6.18196 17.3233 6.63902 17.8721 7.24059L15.7503 9.29299C15.4576 8.90374 15.0735 8.61475 14.5979 8.42603C14.1223 8.2373 13.6346 8.14294 13.1346 8.14294C12.5859 8.14294 12.0828 8.24025 11.6256 8.43487C11.1683 8.6295 10.775 8.89784 10.4458 9.23991C10.1165 9.58198 9.86045 9.98596 9.67753 10.4519C9.49462 10.9178 9.40316 11.4279 9.40316 11.9823C9.40316 12.5485 9.49462 13.0675 9.67753 13.5393C9.86045 14.0111 10.1135 14.4151 10.4366 14.7513C10.7598 15.0875 11.1469 15.3499 11.5981 15.5386C12.0493 15.7274 12.5432 15.8217 13.0797 15.8217C13.7016 15.8217 14.2443 15.7038 14.7077 15.4679C15.171 15.232 15.543 14.9253 15.8234 14.5478L18.0001 16.5295Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

Cars.propTypes = propTypes;
Cars.defaultProps = defaultProps;

export default Cars;
